import { render, staticRenderFns } from "./organClassList.vue?vue&type=template&id=08c5eef7&scoped=true&"
import script from "./organClassList.js?vue&type=script&lang=js&"
export * from "./organClassList.js?vue&type=script&lang=js&"
import style0 from "./organClassList.vue?vue&type=style&index=0&id=08c5eef7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c5eef7",
  null
  
)

export default component.exports